<template>
<div class="close" @click="handleClose">
  <SvgIcon icon-class="close" width="24" height="24"/>
</div>
</template>

<script>
import { postMessage } from '@hll/cashier-kit'

export default {
  name: 'Close',
  methods: {
    handleClose () {
      postMessage({
        action: 'cashierOff',
        status: 1
      })
    }
  }
}
</script>

<style scoped lang="scss">
.close{
  position: fixed;
  top: 8px;
  right: 8px;
}
</style>
